import fetch from './fetchTimeout'

const NOAUTH = 403;
const SERERROR = 500;

export async function getInstitutionDepartments(institutionId, runType) {
    let res;
    try {
        let data = {
            institutionName: institutionId,
            runType
        }
        res = await(fetch(`/v-vd-checks/dept-ids`, {
            method: 'POST',
            body: JSON.stringify(data),
            credentials: 'include',
        }, 90000))
        if(res.status === 403) {
            return NOAUTH;
        }
        if(res.status !== 200) {
            return SERERROR;
        }
        res = await res.json();
    } catch(e) {
        return SERERROR;       
    }
    return res;
}

export async function getInstitutionOverview(institutionId, departmentId, token, runType) {
    let res;
    try {
        let data = {
            institutionName: institutionId,
            departmentId: "" + departmentId,
            runType
        }
        res = await(fetch(`/v-vd-checks/overview`, {
            method: 'POST',
            body: JSON.stringify(data),
            credentials: 'include',
        }, 90000))
        if(res.status === 403) {
            return NOAUTH;
        }
        if(res.status !== 200) {
            return SERERROR;
        }
        res = await res.json();
    } catch (e) {
        return SERERROR;        
    }
    return res;
}

export async function reportExists(institutionId, runType) {
    let res;
    let data = {
        institutionName: institutionId,
        runType
    }
    try{
        res = await(fetch(`/v-vd-checks/report-exists`, {
            method: 'POST',
            body: JSON.stringify(data),
            credentials: 'include',
        }, 90000))
        if(res.status !== 200) {
            return SERERROR;
        }
        res = await res.json();
    } catch(e) {
        return SERERROR;
    }
    return res;
}

export async function availableRuns() {
    let res
    try {
        res = await(fetch('/v-vd-checks/results', {
            method: 'GET',
            credentials: 'include'
        }, 9000))
        if(res.status !== 200) {
            return SERERROR
        }
        res = await res.json()
    } catch(e) {
        return SERERROR
    }
}


export async function resultsGeneral(runType) {
    let res
    try {
        res = await(fetch(`/v-vd-checks/results/general?run-type=${runType}`, {
            method: 'GET',
            credentials: 'include',
        }, 9000))
        if(res.status !== 200) {
            return SERERROR
        }
        res = await res.json()
    } catch(e) {
        return SERERROR
    }
    return res
}

export async function recordsWithErrors(body) {
    let res
    try {
        res = await(fetch('/v-vd-checks/results', {
            method: 'POST',
            body: JSON.stringify(body),
            credentials: 'include'
        }, 90000))
        if(res.status !== 200) {
            return SERERROR
        }
        res = await res.json()
    } catch(e) {
        return SERERROR
    } 
    return res
}

export async function recordWithErrors(recordId) {
    let res
    try {
        res = await(fetch(`/v-vd-checks/results/${recordId}`, {
            method: 'GET',
            credentials: 'include'
        }, 9000))
        if(res.status !== 200) {
            return SERERROR
        }
        res = await res.json()
    } catch(e) {
        return SERERROR
    }
    return res
}

export async function loginAttempt(institutionId, token) {
    let res;
    let data = {
        institutionName: institutionId,
    }
    try {
        res = await(fetch(`/v-vd-checks/validate-token`, {
            method: 'POST',
            body: JSON.stringify(data),
            credentials: 'include',
            headers: new Headers({
                'Authorization': 'Basic ' + btoa(`${institutionId}:${token}`),
        })

        }, 15000))
        if(res.status !== 200) {
            return SERERROR;
        }
        res = await res.json();
    } catch(e) {
        return SERERROR;        
    }
    return res;
}

export async function isMobilePhoneValid(objectID) {
    let res
    try {
        res = await(fetch(`/v-vd-checks/mobilephone-valid/${objectID}`, {
            method: 'GET',
            credentials: 'include'
        }, 15000))
        if(res.status !== 200) {
            return SERERROR
        }
        res = await res.json()
    } catch(e) {
        return SERERROR
    }
    return res;
}

export async function notifyUserSMS(objectID) {
    let res
    let data = {
        objectID
    }
    try {
        res = await(fetch(`/v-vd-checks/sms/notify`, {
            method: 'POST',
            body: JSON.stringify(data),
            credentials: 'include',
            objectID
        }, 15000))
        if(res.status !== 200) {
            return SERERROR
        }
        res = await res.json()
    } catch(e) {
        return SERERROR
    }
    return res
}

export async function isUserNotifiedSMS(objectID) {
    let res
    let data = {
        objectID: String(objectID)
    }
    try {
        res = await(fetch(`/v-vd-checks/sms/is-notified`, {
            method: 'POST',
            body: JSON.stringify(data),
            credentials: 'include',
            objectID
        }, 15000))
        if(res.status !== 200) {
            return SERERROR
        }
        res = await res.json()
    } catch(e) {
        return SERERROR
    }
    return res
}

export async function institutionHasSMSService() {
    let res
    try {
        res = await(fetch(`/v-vd-checks/sms/institution-exists`, {
            method: 'GET',
            credentials: 'include',
        }, 15000))
        if(res.status !== 200) {
            return SERERROR
        }
        res = await res.json()
    } catch(e) {
        return SERERROR
    }
    return res
}

export async function logout() {
    let res
    try {
        res = await(fetch(`/v-vd-checks/logout`, {
            method: 'GET',
            credentials: 'include',
        }, 15000))
        if(res.status !== 200) {
            return SERERROR;
        }
        res = await res.json();
    } catch(e) {
        return SERERROR;        
    }
    return res;
}





// WEBPACK FOOTER //
// ./src/lib/apiCalls.js